module.exports = __webpack_public_path__ + "ewm.a4fd589a.jpg";